<template>
  <div>
    <div id="humm" v-if="hummLoaded">
      <div v-if="tier==0"></div>
      <div v-if="tier==1" :class="dense?'dense':''">
        or pay <b>{{hummData.numberOfRepayments}}</b> fortnightly payments of <b>${{Number(hummData.repaymentAmount).toFixed(2)}}</b> with <a href="https://www.shophumm.com/au/how-it-works/" target="_blank" rel="noopener noreferrer"><img src="../assets/humm-logo-orange.svg" :width="dense?'60':'80'"/></a><span style="cursor:pointer; text-decoration: underline;" @click="showModal = true" v-if="!dense"> more info </span>     
      </div>
      <div v-if="tier==3 && dense" class="dense">
        or pay <b>{{hummData.numberOfRepayments}}</b> fortnightly payments of <b>${{Number(hummData.repaymentAmount).toFixed(2)}}</b> with <a href="https://www.shophumm.com/au/how-it-works/" target="_blank" rel="noopener noreferrer"><img src="../assets/humm-logo-orange.svg" :width="dense?'60':'80'"/></a>
      </div>
      <div v-if="tier==3 && !dense">
        or pay <b>${{hummData.depositAmount}}</b> today, then <b>{{hummData.numberOfRepayments}}</b> fortnightly payments of <b>${{Number(hummData.repaymentAmount).toFixed(2)}}</b> (total payable <b>${{Number(hummData.totalPayableAmount).toFixed(2)}}</b>) <span style="cursor:pointer; text-decoration: underline;" @click="showModal = true"> more info </span> <a href="https://www.shophumm.com/au/how-it-works/" target="_blank" rel="noopener noreferrer"><img src="../assets/humm-logo-orange.svg" width="80"/></a>
      </div>      
    </div>
    <div v-else>
      <q-spinner color="primary" size="1em" />
    </div>      
    <q-dialog v-model="showModal">   
      <div class="humm-price-info-modal" style="min-width:780px">
       <div v-if="tier==1">
          <div class="header">
            <div class="title"><img src="../assets/logo-orange.svg" alt="humm logo"></div>
            <div class="sub-title"><span style = "color: #4D4D4D; font-weight: 750;">Buy Now. Pay Laaaater.</span><span style = "font-weight: 300;"> No interest ever.</span><sup style = "font-weight: 100;">1</sup></div>
          </div>
          <div class="pricing-wrapper">
            <div class="pricing">
              <div class = "summary-content">
                <ul>
                  <li>Fast Approval</li>
                  <li id="m25">Pay over 2.5 months  -  up to $2 Transaction Fee</li>
                  <li id="m50">Pay over 5 months - up to $2 Transaction Fee and $8 per month Account Keeping Fee </li>
                  <li>Weekly or fortnightly payment options (depending on spend)</li>
                  <li>Each payment frees your <span style = "font-weight: 800; color: black;">humm</span> balance to spend again</li>
                </ul>
              </div>
            </div>
          </div>             
        </div>
        <div v-if="tier==3">
          <div class="header">
            <div class="title"><img src="../assets/logo-orange.svg" alt="humm logo"></div>
            <div class="sub-title">
              <span>No interest ever. Pay in slices over <span id='months'>{{hummData.numberOfMonths}}</span> months.</span>
            </div>
          </div>
          <div class="pricing-wrapper">
            <div class="pricing">
              <div class="pricing-left">
                Pay <strong>$<span id='deposit'>{{hummData.depositAmount}}</span></strong> today, then <br> <strong><span id='repayments'>{{hummData.numberOfRepayments}}</span></strong> fortnightly payments of <strong>$<span id='payments'>{{hummData.repaymentAmount}}</span></strong><sup>1</sup>
              </div>
              <div class="pricing-right">
                Total amount payable is <strong>$<span id='total-amount'>{{hummData.totalPayableAmount}}</span></strong>,<br> which includes the
                <strong>$<span id='purchase-amount'>{{hummData.totalPayableAmount - (hummData.numberOfMonths * hummData.monthlyAccountKeepingFee)}}</span></strong> purchase price, <br>
                <span id='fee-repayments'>{{hummData.numberOfMonths}}</span> x <strong>$<span id='mak-fee'>{{hummData.monthlyAccountKeepingFee}}</span></strong> monthly fees, and
                a<br>
                <strong>$<span id='establishment-fee'>{{hummData.establishmentFeeAmount}}</span></strong> establishment fee
              </div>
            </div>
          </div>
        </div>        
        <div class="main-wrapper">
          <div class="main">
            <div class="card">
              <img src="../assets/cart-orange.svg" alt="cart">
              <div class="title">Shop now</div>
              <div class="content">Choose <strong>humm</strong> as your payment option in the online checkout.</div>
            </div>
            <div class="card-dividor">
              <img src="../assets/arrow-orange.svg" alt="">
            </div>
            <div class="card">
              <img src="../assets/login-orange.svg" alt="login">
              <div class="title">Login or Sign Up</div>
              <div class="content">You will be directed to the <strong>humm</strong> portal to login or sign up.</div>
            </div>
            <div class="card-dividor">
              <img src="../assets/arrow-orange.svg" alt="dividor">
            </div>
            <div class="card">
              <img src="../assets/watch-orange.svg" alt="watch">
              <div class="title">Complete Purchase</div>
              <div class="content">Your items will be delivered to your door.</div>
            </div>
          </div>
        </div>
        <div class="footer-wrapper">
          <div class="footer">
            <div class="footer-left">
              <span class="fine-print">Plan to approved applicants only; fees, terms, conditions, minimum amounts and exclusions apply. Payment plan provided by humm BNPL Pty Ltd ABN 28 129 228 986.</span>
            </div>
            <div class="footer-right">
              <span class="fine-print"><span class="orange">What do I need to apply for humm?</span>
              <ul>
                <li>Provide a one-off electronic bank statement.</li>
                <li>Be 18 years or older</li>
                <li>Be a permanent resident or citizen</li>
                <li>Hold an Australian driver's license, Australian passport or Medicare card</li>
                <li>Have a permanent job (at least 25 hours a week) or be on aged/veteran&rsquo;s pension</li>
                <li>Hold an Australian Visa or Mastercard debit or credit card</li>
              </ul>
              </span>
            </div>
          </div>
        </div>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import { formatCurrency } from "../util/string";

export default {
  name: "HummInfo",
  props: ["price","dense"],
  computed: {},
  methods: {
    async getHummRepaymentData(price) {
      if (!this.hummCalled) {
        this.hummCalled = true;
        const response = await fetch(
          `https://3yooylsd64.execute-api.ap-southeast-2.amazonaws.com/dev/getAPI?merchantNumber=30145341&purchaseAmount=${price}`
        );
        this.hummData = await response.json();
        this.hummLoaded = true;
      }
    },
  },
  async mounted() {
    if (this.price > 0 && this.price <= 1000) {
      this.tier = 1;
      this.hummData.numberOfRepayments = 5;
      this.hummData.repaymentAmount =
        this.price / this.hummData.numberOfRepayments;
      this.hummLoaded = true;
    } else if (this.price > 1000 && this.price <= 2000) {
      this.tier = 1;
      this.hummData.numberOfRepayments = 10;
      this.hummData.repaymentAmount =
        this.price / this.hummData.numberOfRepayments;
      this.hummLoaded = true;
    } else if (this.price > 2000 && this.price <= 12000) {
      this.tier = 3;
      await this.getHummRepaymentData(this.price);
    } else {
      this.hummLoaded = true;
    }
  },
  data() {
    return {
      loaded: true,
      showModal: false,
      hummCalled: false,
      hummLoaded: false,
      tier: 0,
      hummData: {},
    };
  },
};
</script>

<style scoped>
@import "../styles/priceApiModal.min.css";

.summary-content {
  font-size: 14px;
  margin-left: 20%
}

.summary-content li {
  list-style-type: disc
}
.dense {
font-size: 12px;
text-align: right;
margin-bottom: 5px;
}


</style>